
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cuisine",
      function () {
        return require("private-next-pages/cuisine.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cuisine"])
      });
    }
  